import { ProductListLink } from '@graphcommerce/magento-product'
import { breakpointVal, Row, extendableComponent } from '@graphcommerce/next-ui'
import { Box, Stack, SxProps, Theme, Typography } from '@mui/material'
import Image from 'next/image'
import React from 'react'
import { CategoryHeroNavFragment } from './CategoryHeroNav.gql'

export type CategoryHeroNavProps = {
  title: React.ReactNode
  description: React.ReactNode
  asset?: React.ReactNode
  sx?: SxProps<Theme>
} & CategoryHeroNavFragment

const cmpName = 'CategoryHeroNav' as const
const parts = ['wrapper', 'categories', 'title', 'placeholder'] as const
const { classes } = extendableComponent(cmpName, parts)

export function CategoryHeroNav({ children, description, title, asset, sx = [] }: CategoryHeroNavProps) {

  return (
    <Row
      className={classes.wrapper}
      maxWidth={false}
      sx={[
        (theme) => ({
          display: 'grid',
          gridTemplateColumns: '1fr',
          gridTemplateAreas: `
            "title"
            "categories"
          `,
          gridTemplateRows: 'auto auto 1fr',
          borderBottom: `1px solid ${theme.palette.divider}`,
          marginBottom: theme.spacings.xxl,
          paddingBottom: theme.page.vertical,
          [theme.breakpoints.up('md')]: {
            width: '100%',
            paddingRight: "6rem",
            paddingLeft: "6rem",
            paddingTop: 0,
            gridColumnGap: 0,
            display: 'grid',
            gridTemplateAreas: `
              ". title title title"
              ". categories categories categories"
            `,
            gridTemplateColumns: '1fr 4.6fr 0.4fr 8fr',
            gridTemplateRows: '1fr',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box
        className={classes.title}
        sx={(theme) => ({
          gridArea: 'title',
          alignSelf: 'center',
          [theme.breakpoints.up('md')]: {
            alignSelf: 'end',
          },
        })}
      >
        {title}
      </Box>
      <Box
        className={classes.title}
        sx={(theme) => ({
          gridArea: 'title',
          alignSelf: 'center',
          [theme.breakpoints.up('md')]: {
            alignSelf: 'end',
          },
        })}
      >
        {description}
      </Box>
   
      <Box
        className={classes.categories}
        sx={(theme) => ({
          gridArea: 'categories',
          display: 'flex',
          flexWrap: 'wrap',
          gap: "2rem",
          // gridColumnGap: theme.spacings.xxl,
          // gridRowGap: theme.spacings.lg,
          height: 'min-content',
          maxWidth: '70vw',
          justifySelf: 'center',
          alignSelf: 'start',
          // gridTemplateColumns: '1fr 1fr',
          marginBottom: theme.spacings.lg,
          [theme.breakpoints.up('md')]: {
            margin: 0,
            // gridColumnGap: theme.spacings.md,
            // gridRowGap: theme.spacings.md,
            maxWidth: '100vw',
            width: '100%',
            justifySelf: 'start',
          },
        })}
      >
        {children?.map((category) => {
          console.log({category})
          if (!category?.url_path || !category.uid || !category.name || !category.include_in_menu)
            return null
          return (
            <ProductListLink
                underline='none'
                color='textPrimary'
                url={category.url_path}
                filters={{ category_uid: { eq: category.uid } }}
                sort={{}}
                key={category.uid}
                
              >
            <Box position="relative" minHeight="20rem" minWidth="25rem" borderRadius="1rem" overflow="hidden">
              
                <Stack direction="column">
                <Typography variant='h4' component='span' fontWeight={700} color={category?.image ? "white" : "black"} zIndex={20} position="absolute" bottom="3rem" left="1.5rem">
                  {category.name}
                </Typography>
                {category?.product_count && <Typography   component='span' fontWeight={400} color="white" zIndex={20} position="absolute" bottom="1rem" left="1.5rem">
                  {category?.product_count} prodotti disponibili
                  </Typography>}

                  </Stack>
              {category?.image && <Image src={category?.image} alt={category.name} fill={true}  style={{position: "absolute", objectFit:"cover", filter: "brightness(0.5)"}} />}

            </Box>
            </ProductListLink>

          )
        })}
      </Box>
      {asset && <Box
        className={classes.placeholder}
        sx={(theme) => ({
          gridArea: 'placeholder',
          minHeight: '40vh',
          overflow: 'hidden',
          display: 'flex',
          '& > div': {
            display: 'flex',
          },
          '& video': {
            objectFit: 'cover',
            width: '100%',
            ...breakpointVal(
              'borderRadius',
              theme.shape.borderRadius * 2,
              theme.shape.borderRadius * 3,
              theme.breakpoints.values,
            ),
          },
          [theme.breakpoints.up('md')]: {
            minHeight: '80vh',
          },
        })}
      >
        <Box>{asset}</Box>
      </Box>}
    </Row>
  )
}
